import ImageCropper from '@/components/imageCropper/imageCropper';
import { postData } from '@/services/api.service';
import { fetchCroppedImage } from '@/utils/constants';
import { ColorPicker } from 'primereact/colorpicker';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import {
  testimonialuser1,
  testimonialuser2,
  testimonialuser3,
} from '@/utils/imagepath';
import { ImageType } from '@/services/openai.service';
import { useSelector, useDispatch } from 'react-redux';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';

function TestimonialEditModal({ themeData, getThemeData }: any) {
  const [editData, setEditData] = useState<any>(themeData);
  const [activeTab, setActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);


  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [iconImages, setIconImages] = useState<string[]>([]);
  const icons = [
    testimonialuser1,
    testimonialuser2,
    testimonialuser3,
    testimonialuser1,
    testimonialuser2,
    testimonialuser3,
  ];

  // Auto-generate prompt based on current card context for profile image
  const generateAutoPromptIcon = (): string => {
    // Get context from the current active card
    const currentCard = editData?.theme_2?.home?.section_7?.cards?.[activeTab];
    const cardName = currentCard?.name || '';
    const cardDesignation = currentCard?.designation || '';
    const cardMessage = currentCard?.message || '';
    
    // Build context-based prompt for profile image
    let contextPrompt = 'professional profile portrait';
    
    if (cardName || cardDesignation || cardMessage) {
      const contextParts: string[] = [];
      if (cardMessage) {
        // Extract keywords from message
        const keywords = cardMessage.split(' ').slice(0, 3).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add profile-specific styling
    contextPrompt += ', professional headshot, friendly expression, clean background, suitable for testimonial profile, high quality portrait, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI profile image save
  const handleAIIconSave = (imageUrl: string) => {
    // Auto-apply the profile image to the current active card
    handleImageChange(imageUrl, activeTab);
    
    // Add to icon images array for slider
    setIconImages(prevIcons => [...prevIcons, imageUrl]);
  };

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  const addCollection = () => {
    let updatedCollection: any = [...editData.theme_2.home.section_7.cards];

    let newCard = {
      profile: testimonialuser1,
      name: '',
      designation: '',
      message: '',
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        home: {
          ...prevJsonData.theme_2.home,
          section_7: {
            ...prevJsonData.theme_2.home.section_7,
            cards: updatedCollection,
          },
        },
      },
    }));
  };

  const removeCollection = () => {
    let updatedCollection: any = [...editData.theme_2.home.section_7.cards];
    updatedCollection.splice(activeTab, 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        home: {
          ...prevJsonData.theme_2.home,
          section_7: {
            ...prevJsonData.theme_2.home.section_7,
            cards: updatedCollection,
          },
        },
      },
    }));
  };
  const handleChange = (e: any) => {
    const { value, name, type, checked } = e.target;
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_7: {
            ...prevJsonData.theme_2.home.section_7,
            [name]: value,
          },
        },
      },
    }));
  };
  const handleCardChange = (e: any) => {
    const updatedCollection = [...editData.theme_2.home.section_7.cards];
    const { value, name } = e.target;
    updatedCollection[activeTab] = {
      ...updatedCollection[activeTab],
      [name]: value,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        home: {
          ...prevJsonData.theme_2.home,
          section_7: {
            ...prevJsonData.theme_2.home.section_7,
            ...prevJsonData.theme_2.home.section_7.cards,
            cards: updatedCollection,
          },
        },
      },
    }));
  };
  const handleImageChange = (image: string, index: any) => {
    const updatedCollection = [...editData.theme_2.home.section_7.cards];
    updatedCollection[index] = {
      ...updatedCollection[index],
      profile: image,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        home: {
          ...prevJsonData.theme_2.home,
          section_7: {
            ...prevJsonData.theme_2.home.section_7,
            ...prevJsonData.theme_2.home.section_7.cards,
            cards: updatedCollection,
          },
        },
      },
    }));
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink, activeTab);
    }
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };
  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load profile images from Redux (filtered by 128x128 size)
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template2';
      const currentTemplate = templateImages[templateKey];
      const imageArray = currentTemplate?.image || [];
      
      if (Array.isArray(imageArray) && imageArray.length > 0) {
        // Filter images that are 128x128
        const loadImageDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
              resolve({ url, width: img.width, height: img.height });
            };
            img.onerror = () => {
              resolve(null);
            };
            img.src = url;
          });
        };

        const filterImages = async () => {
          const imagePromises = imageArray.map((img: any) => loadImageDimensions(img.url));
          const loadedImages = await Promise.all(imagePromises);
          
          const filtered128Images = loadedImages
            .filter((img) => img !== null && img.width === 128 && img.height === 128)
            .map((img) => img!.url);
          
          setIconImages(filtered128Images);
        };

        filterImages();
      } else {
        setIconImages([]);
      }
    } else {
      setIconImages([]);
    }
  }, [templateImages, template]);

  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section7 Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title One<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title_1"
                      value={editData?.theme_2?.home?.section_7?.title_1}
                      onChange={handleChange}
                      maxLength={250}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Title Two</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title_2"
                      value={editData?.theme_2?.home.section_7?.title_2}
                      onChange={handleChange}
                      maxLength={1200}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 1 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={editData?.theme_2?.home?.section_7?.h2color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_2?.home?.section_7?.h2color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 2 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h3color"
                        value={editData?.theme_2?.home?.section_7?.h3color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h3color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_2?.home?.section_7?.h3color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={editData?.theme_2?.home?.section_7?.paracolor}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_2?.home?.section_7?.paracolor}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_2?.home?.section_7?.cards.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option-wrapper">
                          <a
                            className={`nav-link ${
                              activeTab === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Testimonial {index + 1}
                          </a>
                          <a
                            className="nav-option-close"
                            onClick={() => {
                              removeCollection();
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_2?.home?.section_7?.cards.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? 'show active' : ''
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active">
                            <img
                              src={card.profile}
                              alt={`Card Icon ${index + 1}`}
                            />
                          </div>
                          <div className="img-options w-100">
                            {iconImages.length > 0 ? (
                            <Swiper
                              spaceBetween={15}
                              navigation={true}
                              modules={[Navigation]}
                              breakpoints={{
                                640: {
                                  slidesPerView: 1,
                                },
                                768: {
                                  slidesPerView: 4,
                                },
                                1024: {
                                  slidesPerView: 6,
                                },
                              }}
                              className="homejson-slider"
                            >
                                {iconImages.map((iconUrl, iconIndex) => (
                                <SwiperSlide key={iconIndex}>
                                  <div
                                    className="img-option"
                                    onClick={() =>
                                        handleImageChange(iconUrl, index)
                                    }
                                  >
                                    <img
                                        src={iconUrl}
                                        alt="Profile Image"
                                      className="img-fluid"
                                    />
                                  </div>
                                </SwiperSlide>
                              ))}
                            </Swiper>
                            ) : (
                              <div className="empty-slider-state text-center py-4">
                                <div className="empty-state-content">
                                  <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                  <h6 className="text-muted mb-2">No Profile Images Available</h6>
                                  <p className="text-muted small mb-3">
                                    Generate AI profile images or upload your own to see them here
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* AI Profile Image Generator */}
                      <AIImageGenerator
                        generateAutoPrompt={generateAutoPromptIcon}
                        onSave={handleAIIconSave}
                        imageType="image"
                        defaultWidth="128"
                        defaultHeight="128"
                        title="AI Image"
                        autoGenerate={true}
                        template={template}
                      />

                      <div className="mb-3">
                        <label className="form-label">Upload Image</label>
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control"
                          name="image"
                          onChange={updateImageSectionOne}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">
                          Name<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={card.name}
                          onChange={handleCardChange}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Designation
                          <small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="designation"
                          value={card.designation}
                          onChange={handleCardChange}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                          <label className="form-label mb-0 mr-2">Message</label>
                          <AIContentWriter
                            onContentGenerated={(content) => {
                              handleCardChange({
                                target: {
                                  name: 'message',
                                  value: content,
                                },
                              });
                            }}
                            contentType="testimonial"
                            placeholder="Describe the testimonial message you want. Example: 'Write a positive review about excellent customer service'"
                            context="This is for a customer testimonial message"
                          />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          name="message"
                          value={card.message}
                          onChange={handleCardChange}
                          maxLength={1200}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="add-section">
              <div className="row">
                <div
                  onClick={() => {
                    addCollection();
                  }}
                  className="col text-center"
                >
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonData();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
}

export default TestimonialEditModal;
